import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getRecipientTypeParam, providerCategories } from 'apps/auth/components/utils/AmplitudeUtils';
import { TRANSFER_STATUS_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYMENT_METHOD_AMPLITUDE, PAYOUT_COUNTRY, PAYOUT_METHOD, RECIPIENT_TYPE, STATUS } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FINAL_FAIL, FINAL_OK, PROCESSING, WARNING } from 'apps/auth/constants/Constants';
import { getDDMonEEEHHmmDate } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import { IconWrap, Item, ItemContent, StatusList } from './styles';

const TransferStatusScreen = (props) => {
    const { transferStatusTitle } = usePageMessages();

    useEffect(() => {
        const amplitudeDeliveryMethod = providerCategories[props.cheque.providerToCategory];
        const amplitudePaymentMethod = providerCategories[props.cheque.providerFromCategory];
        let statusParam;
        if (props.paymentStatusHistory?.length > 0) {
            props.paymentStatusHistory.forEach((statusObj) => {
                if (statusObj.date) {
                    statusParam = statusObj.statusMsg;
                }
            });
        }
        amplitude.getInstance().logEvent(TRANSFER_STATUS_SHOWN, {
            [STATUS]: statusParam,
            [PAYOUT_COUNTRY]: props.cheque.toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [PAYMENT_METHOD_AMPLITUDE]: amplitudePaymentMethod,
            [RECIPIENT_TYPE]: getRecipientTypeParam(props.cheque.recipientType),
        });
    }, []);

    const getStatusIcon = (currentStatus, currentStatusOrder) => {
        let iconName = '';
        const isRedIcon = currentStatus === WARNING || currentStatus === FINAL_FAIL;

        if (currentStatus === PROCESSING) {
            iconName = 'status-wait';
        } else if (currentStatus === FINAL_OK) {
            iconName = 'status-success';
        } else if (currentStatus === FINAL_FAIL) {
            iconName = 'status-error';
        } else if (currentStatus === WARNING) {
            iconName = 'status-alert';
        }
        if (iconName && currentStatusOrder >= 0) {
            return (
                <IconWrap>
                    <Icon name={iconName} color={isRedIcon ? 'error' : 'primary'} />
                </IconWrap>
            );
        }
        return null;
    };

    const isPassed = (i) => {
        return props.paymentStatusHistory[i + 1]?.date;
    };

    if (props.paymentStatusHistory?.length > 0) {
        return (
            <>
                <HeaderPanel title={transferStatusTitle} />
                <StatusList>
                    {props.paymentStatusHistory.map((statusObj, i) => {
                        const { date, order, statusDescription, statusHint, statusMsg, draft } = statusObj;
                        const formattedDate = date ? getDDMonEEEHHmmDate(date, props.lang) : null;
                        return (
                            <Item key={`status-${order}`} isPassed={isPassed(i)} isActive={!!date}>
                                {getStatusIcon(statusHint, i)}
                                <ItemContent>
                                    <Text variant="div" color={date || draft ? 'primary' : 'secondary'} indent="4px">
                                        {statusMsg}
                                    </Text>
                                    <Text variant="div" size="secondary" color="lightGray" indent="8px">
                                        {formattedDate}
                                    </Text>
                                    <Text variant="div" color="secondary">
                                        {MarkdownService.splitByParagraph(statusDescription || '', [], { color: 'lightGray' })}
                                    </Text>
                                </ItemContent>
                            </Item>
                        );
                    })}
                </StatusList>
            </>
        );
    } else {
        return (
            <InfoPage
                insideModalComponent={true}
                animatedIconFail
                headerText={props.noTransactionDetailsTitle}
                primaryButtonCaption={props.goBack}
                primaryButtonOnClick={props.onCloseModalClick}
            />
        );
    }
};

export default TransferStatusScreen;
